import { makeStyles } from "@material-ui/core";
import { size, DsText, DsIcon } from "@mvp/design-system";
import React from "react";

const useStyles = makeStyles((theme) => ({
  modalTitle: {
    marginBottom: size.xs(theme),
  },
}));

export const ContentTitle: React.FC<{ text: string; showIcon?: boolean }> = (
  props
) => {
  const classes = useStyles();

  return (
    <>
      {props.showIcon ? (
        <DsIcon title="Exclamation-circle" icon="fas fa-exclamation-circle" />
      ) : null}
      <DsText className={classes.modalTitle} variant="h1" text={props.text} />
    </>
  );
};
